module.exports = __webpack_public_path__ + "static/media/avatar36.05d8d02c.png";